import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../constants/globalConstants'

function ConfirmationTerms(props) {
    const { isConfimationModalOpen, setIsConfimationModalOpen, Message, cancelButton, SubmitButton, cancelButtonLabel, SubmitButtonLable, SubmitButtonColor, handleLogout, handleSubmit, isHandleSubmit, warning, data, cancleButtonColor, setIsSubmittingForm, isSubmittingForm } = props
    
    const handleClose = () => {
        setIsConfimationModalOpen()
        if(setIsSubmittingForm) {
            setIsSubmittingForm()
        }
    }

    const handleFormSubmit = () => {
        if(setIsSubmittingForm) {
            setIsSubmittingForm(true)
        }
        handleSubmit(warning, data)
    }
    return (
        <>
            <Modal show={isConfimationModalOpen} onHide={() => handleClose()} centered>
                <Modal.Body className='messageCss'>{Message}</Modal.Body>
                <Modal.Footer className='confirationModalfooter py-0'>
                    {(cancelButton) && <Button variant={`light ${cancleButtonColor}`} className='logoutListMenu pt-0 pb-2' onClick={() => handleClose()}>{cancelButtonLabel}</Button>}
                    {(SubmitButton) && <Button variant={`light ${SubmitButtonColor}`} className='logoutListMenu pt-0 pb-2' onClick={() => handleLogout()}>{SubmitButtonLable}</Button>}
                    {isHandleSubmit && <Button variant={`light ${SubmitButtonColor}`} className='logoutListMenu pt-0 pb-2' onClick={() => handleFormSubmit(warning, data)} disabled={isSubmittingForm}>{SubmitButtonLable}</Button>}
                </Modal.Footer>
            </Modal>
        </>
    )
}

ConfirmationTerms.propTypes = {
    dispatch: PropTypes.func,
    isConfimationModalOpen: PropTypes.bool,
    setIsConfimationModalOpen: PropTypes.func,
    Message: PropTypes.string,
    cancelButton: PropTypes.bool,
    cancelButtonLabel: PropTypes.string,
    SubmitButton: PropTypes.bool,
    SubmitButtonLable: PropTypes.string,
    SubmitButtonColor: PropTypes.string,
    handleLogout: PropTypes.func,
    handleSubmit: PropTypes.func,
    isHandleSubmit: PropTypes.bool,
    warning: PropTypes.string,
    data: PropTypes.object,
    cancleButtonColor: PropTypes.string,
    setIsSubmittingForm: PropTypes.func,
    isSubmittingForm: PropTypes.bool,

}

ConfirmationTerms.defaulProps = {
    dispatch: noop,
    isConfimationModalOpen: false,
    setIsConfimationModalOpen: noop,
    Message: '',
    cancelButton: false,
    cancelButtonLabel: '',
    SubmitButton: false,
    SubmitButtonLable: '',
    SubmitButtonColor: '',
    handleLogout: noop,
    handleSubmit: noop,
    isHandleSubmit: false,
    warning: '',
    data: EMPTY_OBJECT,
    cancleButtonColor: '',
    setIsSubmittingForm: null,
    isSubmittingForm: false,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ConfirmationTerms)